// extracted by mini-css-extract-plugin
export var resizer = "_f3-0";